module.exports = __webpack_public_path__ + "static/media/montserrat-v14-latin-regular.bc3aa95d.woff2";